import { render, staticRenderFns } from "./productionInfo.vue?vue&type=template&id=5c51a206&scoped=true&"
import script from "./productionInfo.vue?vue&type=script&lang=js&"
export * from "./productionInfo.vue?vue&type=script&lang=js&"
import style0 from "./productionInfo.vue?vue&type=style&index=0&id=5c51a206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51a206",
  null
  
)

export default component.exports